module.exports = __webpack_public_path__ + "img/image90.990ccbff.jpg";